import {Directive, forwardRef} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {SecurityAutocompleteDirective} from '../../../../components/security-autocomplete';
import {SecurityAutocompleteListModComponent} from './security-autocomplete-list-mod.component';

@Directive({
    selector: '[securityAutocomplete]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SecurityAutocompleteModDirective),
            multi: true
        }
    ],
    standalone: false
})
export class SecurityAutocompleteModDirective extends SecurityAutocompleteDirective {

    protected override readonly listComponentClass = SecurityAutocompleteListModComponent;

}
